module.exports = __webpack_public_path__ + "static/media/logow.d90882a7.webp";